const pro = 'https://api.hfbsoftware.com'
const dev = 'https://test.hfbsoftware.com'

const host = {}
host.host = process.env.NODE_ENV === 'production' ? pro : dev
host.mode = process.env.NODE_ENV === 'production' ? 'pro' : 'dev'


export default host


// WEBPACK FOOTER //
// ./src/Interface/host.js